import React from 'react';
import SwitchViewMode from '../../common/SwitchViewMode';
import { useTranslation } from 'react-i18next';
import { RootState, useDispatch, useSelector } from '../../../redux/store';
import { setSelectedViewMode } from '../../../redux/slices/approval';
import { APPROVAL_VIEW_MODES } from '../../../constants';
import type { ApprovalViewMode } from '../../../types/approval';
import type { ViewModeButton } from '../../../types/common';

const ChangeViewMode = (): React.ReactElement => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { selectedViewMode } = useSelector((state: RootState) => state.approval);
  const modes: ViewModeButton<ApprovalViewMode>[] = [
    {
      id: APPROVAL_VIEW_MODES.CONFIRM,
      active: selectedViewMode === APPROVAL_VIEW_MODES.CONFIRM,
      label: t('approval.unapprovedList'),
    },
    {
      id: APPROVAL_VIEW_MODES.HISTORY,
      active: selectedViewMode === APPROVAL_VIEW_MODES.HISTORY,
      label: t('approval.approvedList'),
    },
  ];

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  // ボタンをクリックして承認済みビューと編集中ビューを切り替えたとき
  const handleClick = (event: React.MouseEvent<{ id: ApprovalViewMode }>) => {
    // console.log(event.currentTarget.id);
    dispatch(setSelectedViewMode(event.currentTarget.id));
  };

  // VIEW
  // ================================================================================

  return <SwitchViewMode modes={modes} onSwitch={handleClick} />;
};

export default ChangeViewMode;
